import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map, catchError, of } from "rxjs";
import { AuthLogin } from "../../models/auth/auth-login.model";
import { environment } from "../../../../environments/environment";
import { AuthToken } from "../../models/auth/auth-token.model";
import { AuthRegister } from "../../models/auth/auth-register.model";


@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private isLoggingOut = false;

    constructor(private http: HttpClient) {}

    login(payload: AuthLogin): Observable<{ authToken: AuthToken}> {
        const url = environment.user.auth;
        return this.http.post<{ authToken: AuthToken }>(url, payload, { withCredentials: true });
    }

    refreshToken(): Observable<{ authToken: AuthToken}> {
        const url = environment.user.refresh;
        return this.http.post<{ authToken: AuthToken }>(url, {}, { withCredentials: true });
    }

    register(payload: AuthRegister): Observable<{ authToken: AuthToken }> {
        const url = environment.user.register;
        return this.http.post<{ authToken: AuthToken }>(url, payload, { withCredentials: true });
    }

    logout(): void {
        this.isLoggingOut = true;
        this.http.post(environment.user.logout, {}, { withCredentials: true })
            .subscribe({
                next: () => { this.isLoggingOut = false; },
                error: () => { this.isLoggingOut = false; }
            });
    }

    isLogoutInProgress(): boolean {
        return this.isLoggingOut;
    }

    isAuthenticated(): Observable<boolean> {
        const url = environment.user.validate;
        return this.http.get<any>(url, { withCredentials: true }).pipe(
            map(() => true),
            catchError(() => of(false))
        );
    }

    verifyEmail(token: string): Observable<void> {
        const url = environment.user.verifyEmail;
        return this.http.post<void>(url, { token }, { withCredentials: true });
    }

    resendVerificationEmail(email: string): Observable<void> {
        const url = environment.user.resendVerificationEmail;
        return this.http.post<void>(url, { email }, { withCredentials: true });
    }
}